const apiBase = "https://ets.equatorsolution.com:3001";
// const apiBase = "http://localhost:3001";
export { apiBase };
